import React, {Component} from 'react'

import UserContextMenu from '../UserContextMenu/index';
import UserContextMenuItem from '../UserContextMenuItem/index';

import Registry from '../../../registry/index';
import Snapshot from '../UserInfoTooltip/Snapshot';
import ShortUserInfo from '../UserInfoTooltip/ShortUserInfo';
import ShortAdminInfo from '../UserInfoTooltip/ShortAdminInfo';

class UserListItemContextMenuMobile extends UserContextMenu {
    action(event, name) {
        super.action(event, name);

        let {hideRightSidebar, onContextMenuHidden} = this.props;
        hideRightSidebar();

        // calling parent's event to hide the menu
        onContextMenuHidden();
    }

    render() {
        let lang = Registry.get('locale');

        let {user, currentUser, currentRoom, openVideoWindow} = this.props;

        let allItems = super.getAllItems(lang, user, currentRoom),
            availableItems = [];

        for (let action in allItems) {
            let item = allItems[action];
            let disabled = !super.itemEnabled(action, user, currentUser);

            if (super.itemVisible(action, user, currentUser)) {
                availableItems.push(<UserContextMenuItem key={action} {...item} disabled={disabled}/>);
            }
        }

        return (
            <div className="block-menu" ref={(ref) => this._ref = ref}>
                <ul>
                    <li className="info">
                        <Snapshot 
                            user={user} 
                            currentUser={currentUser}
                            action={(event, name) => this.action(event, name)}
                            openVideoWindow={openVideoWindow}
                        />
                        <i>
                            <ShortUserInfo 
                                user={user}
                                lang={lang}
                            />
                        </i>
                    </li>
                    {availableItems}
                    {user.mood ? 
                        <li className="info mood">
                            <i>
                                <b>{lang.mood}: </b> {user.mood}
                            </i>
                        </li> 
                    : null}
                </ul>
                <ShortAdminInfo data={user.admin_data} />
                <ShortAdminInfo data={user.hitagi_admin_data} />
            </div>
        )
    }

}

export default UserListItemContextMenuMobile;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/UserListItemContextMenuMobile/index.js